import React, { useState } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { ButtonPushable } from './ButtonPushable'

type fontStyleProps = {
    isEnabled: boolean
    isBold: boolean
    isItalic: boolean
    configItemType: string
    changeValueConfig: (
        value: any,
        configItemType: string,
        configItemKey: string,
        setValueState?: (value) => void
    ) => void
}

export const FontStyle = ({
    isEnabled,
    isBold,
    isItalic,
    configItemType,
    changeValueConfig
}: fontStyleProps): JSX.Element => {
    const [isBoldEnabled, setIsBold] = useState(isBold)
    const [isItalicEnabled, setIsItalic] = useState(isItalic)

    return (
        <Container>
            <ConfigLabel>{i18n('Font style')}</ConfigLabel>

            <ButtonContainer>
                <ButtonPushable
                    buttonContent="far fa-bold"
                    isEnabled={isEnabled}
                    isSelected={isBoldEnabled}
                    onClick={() => changeValueConfig(!isBoldEnabled, configItemType, 'isBold', setIsBold)}
                />
                <ButtonPushable
                    buttonContent="far fa-italic"
                    isEnabled={isEnabled}
                    isSelected={isItalicEnabled}
                    onClick={() => changeValueConfig(!isItalicEnabled, configItemType, 'isItalic', setIsItalic)}
                />
            </ButtonContainer>
        </Container>
    )
}

const ConfigLabel = styled.div`
    font-weight: 600;
    color: ${({ theme }) => theme?.['gray-800'] || '#364159'} !important;
    padding-bottom: 8px;
    margin: 0px !important;
    width: 100%;
`

const Container = styled.div`
    padding: 0px 16px;
    width: 100%;
`

const ButtonContainer = styled.div`
    display: flex;
    width: 100%;
    button + button {
        margin-left: 10px;
    }
    .fa-bold {
        font-weight: bold;
    }
`
